import React from "react";
import {
  Image,
  ImageField,
  Link,
  LinkField,
} from "@sitecore-jss/sitecore-jss-react";
import "./index.scss";

type FooterAIButtonProps = {
  link: LinkField;
  icon: ImageField;
};

const FooterAIButton: React.FC<FooterAIButtonProps> = ({ link, icon }) => {
  return (
    <Link className="FooterAIButton" field={link}>
      <Image field={icon} width={20} height={21.98} />
      <span>{link?.value?.text}</span>
    </Link>
  );
};

export default FooterAIButton;
